const Navigation = {
  mounted() {
    const liveSocket = this.liveSocket
    const link = this.el.getAttribute('data-link') || 'redirect'
    const type = this.el.getAttribute('data-link-type') || 'push'

    this.el.addEventListener('change', (event) => {
      if (event.target.value === '#') {
        return
      }

      liveSocket.requestDOMUpdate(() => {
        if (link === 'patch') {
          liveSocket.pushHistoryPatch(event, event.target.value, type)
        }

        if (link === 'redirect') {
          liveSocket.historyRedirect(event, event.target.value, type)
        }
      })
    })
  },
}

export default Navigation
